export const defaultState = () => ({
	step: 0,
	forward: true,
	complete: false,
	extraFeatures: ['google-analytics', 'social-proof', 'seo'],
});

const state = defaultState();

export default state;
